import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../../components/ui/Card/Card';
import Button from '../../components/ui/Button/Button';
import Input from '../../components/ui/Input/Input';
import Select from '../../components/ui/Select/Select';
import Switch from '../../components/ui/Switch/Switch';
import './SettingsScreen.css';

const SettingsScreen = () => {
    const navigate = useNavigate();
    const [active_section, setActiveSection] = useState('profile');
    const [profile_data, setProfileData] = useState({
        firstName: 'John',
        lastName: 'Doe',
        email: 'john.doe@example.com',
        phoneNumber: '+1 (555) 123-4567'
    });
    const [settings, setSettings] = useState({
        notifications: true,
        darkMode: false,
        language: 'en',
        timezone: 'UTC',
        autoSave: true
    });

    // ==== PROFILE HANDLERS ========================================================================================

    const handle_profile_change = (field, value) => {
        setProfileData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handle_setting_change = (setting, value) => {
        setSettings(prev => ({
            ...prev,
            [setting]: value
        }));
    };

    const handle_save_profile = () => {
        // Handle profile save logic here
        console.log('Saving profile:', profile_data);
        // Show success message or handle API call
    };

    const handle_save_settings = () => {
        // Handle settings save logic here
        console.log('Saving settings:', settings);
        // Show success message or handle API call
    };

    const handle_back_click = () => {
        navigate('/home');
    };

    // ================================================================================================================

    // ==== RENDER FUNCTIONS ========================================================================================

    const render_profile_settings = () => {
        return (
            <>
                <div className="section-header">
                    <h2 className="section-title">Profile Settings</h2>
                    <Button
                        onClick={handle_save_profile}
                        variant="primary"
                        className="save-button"
                    >
                        Save Profile
                    </Button>
                </div>
                
                <div className="profile-fields">
                    <div className="profile-field-row">
                        <div className="profile-field">
                            <label className="setting-label">First Name</label>
                            <Input
                                type="text"
                                value={profile_data.firstName}
                                onChange={(e) => handle_profile_change('firstName', e.target.value)}
                                placeholder="Enter your first name"
                            />
                        </div>
                        
                        <div className="profile-field">
                            <label className="setting-label">Last Name</label>
                            <Input
                                type="text"
                                value={profile_data.lastName}
                                onChange={(e) => handle_profile_change('lastName', e.target.value)}
                                placeholder="Enter your last name"
                            />
                        </div>
                    </div>

                    <div style={{ height: '10px' }}></div>

                    <div className="profile-field-row">
                        <div className="profile-field">
                            <label className="setting-label">Email</label>
                            <Input
                                type="email"
                                value={profile_data.email}
                                onChange={(e) => handle_profile_change('email', e.target.value)}
                                placeholder="Enter your email address"
                            />
                        </div>

                        <div className="profile-field">
                            <label className="setting-label">Phone Number</label>
                            <Input
                                type="tel"
                                value={profile_data.phoneNumber}
                                onChange={(e) => handle_profile_change('phoneNumber', e.target.value)}
                                placeholder="Enter your phone number"
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const render_content = () => {
        switch (active_section) {
            case 'profile':
                return render_profile_settings();
            case 'notifications':
                return (
                    <>
                        <div className="section-header">
                            <h2 className="section-title">Notification Settings</h2>
                            <Button
                                onClick={handle_save_settings}
                                variant="primary"
                                className="save-button"
                            >
                                Save
                            </Button>
                        </div>
                        <div className="setting-item">
                            <div className="setting-info">
                                <label className="setting-label">Notifications</label>
                                <p className="setting-description">Receive notifications for important updates</p>
                            </div>
                            <Switch
                                checked={settings.notifications}
                                onChange={(e) => handle_setting_change('notifications', e.target.checked)}
                            />
                        </div>
                    </>
                );
            case 'feedback':
                return (
                    <>
                        <h2 className="section-title">Feedback</h2>
                        <p>Share your feedback and suggestions with us...</p>
                    </>
                );
            case 'support':
                return (
                    <>
                        <h2 className="section-title">Support</h2>
                        <p>Get help and contact support...</p>
                    </>
                );
            default:
                return render_profile_settings();
        }
    };

    // ================================================================================================================

    return (
        <div className="settings-screen">
            <div className="header-container">
                <button className="settings-back-button" onClick={handle_back_click}>
                    <i className="fas fa-arrow-left"></i>
                    <span>Back</span>
                </button>
                <div className="settings-header">
                    <h1 className="settings-title">Settings</h1>
                </div>
            </div>
            
            <div className="settings-layout">
                {/* Left Side Panel */}
                <div className="settings-side-panel">
                    <Card className="side-panel-card">
                        <nav className="settings-navigation">
                            <button
                                className={`nav-item ${active_section === 'profile' ? 'active' : ''}`}
                                onClick={() => setActiveSection('profile')}
                            >
                                <i className="fas fa-user"></i>
                                <span>Profile</span>
                            </button>
                            
                            {/* Temporarily hidden - Notifications option
                            <button
                                className={`nav-item ${active_section === 'notifications' ? 'active' : ''}`}
                                onClick={() => setActiveSection('notifications')}
                            >
                                <i className="fas fa-bell"></i>
                                <span>Notifications</span>
                            </button>
                            */}
                            
                            {/* Temporarily hidden - Feedback and Support options */}
                            {/* 
                            <button
                                className={`nav-item ${active_section === 'feedback' ? 'active' : ''}`}
                                onClick={() => setActiveSection('feedback')}
                            >
                                <i className="fas fa-comment"></i>
                                <span>Feedback</span>
                            </button>
                            
                            <button
                                className={`nav-item ${active_section === 'support' ? 'active' : ''}`}
                                onClick={() => setActiveSection('support')}
                            >
                                <i className="fas fa-question-circle"></i>
                                <span>Support</span>
                            </button>
                            */}
                        </nav>
                    </Card>
                </div>

                {/* Main Content Area */}
                <div className="settings-main-content">
                    <Card className="settings-card">
                        {render_content()}
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default SettingsScreen;
